module.exports = __webpack_public_path__ + "img/tu-3.3f70ef99.png";